import { render, staticRenderFns } from "./SolarSystem.vue?vue&type=template&id=fca8b048"
import script from "./SolarSystem.vue?vue&type=script&lang=js"
export * from "./SolarSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports